import { Component, Input } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { MeasurementToolModel } from '@evorait/pace-core';

@Component({
    selector: 'pace-calibration-date',
    templateUrl: './calibration-date.component.html',
})
export class CalibrationDateComponent {
    @Input()
    public model: MeasurementToolModel;
    public constructor(public readonly modalInstance: BsModalRef) {}
}
